import getApi from '@/lib/axios';
import { CommentModel, CrmType } from '../types';

export type CommentDTO = CommentModel;

async function createComment(payload: CommentDTO) {
  const api = await getApi();

  return api.post<CrmType>('/crm/comentarios/', payload);
}

export { createComment };
